// <!-- ============================================================================= -->
// <!-- Ella Custom JS - Customize The Style For Layout -->
// <!-- ============================================================================= -->

// <!-- ============================================================================= -->
// <!-- IMPORTANT DISCLAIMER -->
// <!-- Please use only JS to style the layout. -->
// <!-- ============================================================================= -->
$("table").wrap("<div class='admin-table_scroll'></div>");
